'use client';

import type { Product } from '@/lib/shopify/types';
import type { DigitisingFeeData } from '@/app/products/[handle]/product-page-client';
import ProductPageClient from '@/app/products/[handle]/product-page-client';

interface DesignProductShellProps {
  product: Product;
  digitisingFees: {
    front: DigitisingFeeData | null;
    back: DigitisingFeeData | null;
  };
}

export default function DesignProductShell({ product, digitisingFees }: DesignProductShellProps) {
  return (
    <ProductPageClient
      key={product.id}
      product={product}
      relatedProducts={[]}
      digitisingFees={digitisingFees}
      embedded
      hideRelated
      designExperience
    />
  );
}
